import { Link } from 'react-router-dom'
import Translation from '../../Translation/cont/Translation'

const PrintTypeItem = ({id, transIdname, path, transIdDescription}) => (
    <Link className={"type-link-wrapper " + id} to={path}>
        <div className="type-link-content">
            <div className="top-wrapper">
                <div className="icon-wrapper">
                    <div className={"icon " + id}></div>
                </div>
            </div>
            <div className="text-wrapper">
                <p className="title-large-light"><Translation id={transIdname}/></p>
                <p className="text-light description"><Translation id={transIdDescription}/></p>
            </div>
        </div>
    </Link>
)

export default PrintTypeItem  